module.exports = __webpack_public_path__ + "br.8909bc2f.svg";